import { render, staticRenderFns } from "./Reversal.vue?vue&type=template&id=07cb8328&"
import script from "./Reversal.vue?vue&type=script&lang=js&"
export * from "./Reversal.vue?vue&type=script&lang=js&"
import style0 from "./Reversal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports